import { Component, computed, input } from '@angular/core';

import { LinkComponent } from '@valk-nx/components/ui-link/src/lib/link';
import type { Link } from '@valk-nx/components/ui-link/src/lib/link.interface';
import { StoryblokDirective } from '@valk-nx/storyblok-directives/src/lib/directives/storyblok.directive';
import { StoryblokRootDirective } from '@valk-nx/storyblok-directives/src/lib/directives/storyblok-root.directive';
import type { Link as StoryblokLink } from '@valk-nx/storyblok-types/src/lib/types/storyblok.interface';

type AnchorButtonType = 'primary' | 'secondary';
type AnchorButtonVariant = 'normal' | 'outline' | 'text' | 'underline';

const buttonTypeClassNames: Record<AnchorButtonType, string> = {
	primary: 'btn btn-primary',
	secondary: 'btn btn-secondary',
};

const buttonVariantClassNames: Record<AnchorButtonVariant, string> = {
	normal: '',
	outline: 'btn-outline',
	text: 'btn-text',
	underline: 'btn-underline',
};

@Component({
	selector: 'sb-anchor',
	templateUrl: './anchor.html',
	imports: [LinkComponent, StoryblokDirective],
})
export class AnchorComponent extends StoryblokRootDirective {
	text = input.required<string>();
	link = input.required<StoryblokLink>();
	type = input<AnchorButtonType>('primary');
	variant = input<AnchorButtonVariant>('normal');

	buttonClassName = computed(() => {
		// Storyblok types the button type as a free-form string and content
		// still carries cta and tertiary, so an unrecognised type keeps
		// rendering as secondary instead of dropping out of the class list.
		const typeClassName =
			buttonTypeClassNames[this.type()] || buttonTypeClassNames.secondary;
		const variantClassName = buttonVariantClassNames[this.variant()] || '';

		return `${typeClassName} ${variantClassName}`.trim();
	});

	anchorLink = computed<Link>(() => ({
		url:
			this.link().linktype === 'email'
				? `mailto:${this.link().cached_url}`
				: this.link().cached_url,
		title: this.text(),
		target: this.link().target,
	}));
}
